var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#D9D9D9",
    stroke: "#000000",
    cx: 32,
    cy: 32,
    r: 31.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.316,30.049h-5.072v-2.341h5.072l0,0h2.342l0,0h5.074v2.341h-5.074 M28.878,31.961c-1.717,0-3.122-0.546-4.214-1.639 c-1.093-1.092-1.639-2.498-1.639-4.214c0-1.717,0.546-3.122,1.639-4.215c1.092-1.093,2.498-1.639,4.214-1.639 c1.717,0,3.122,0.546,4.215,1.639s1.64,2.498,1.64,4.215c0,1.717-0.547,3.122-1.64,4.214C32,31.415,30.595,31.961,28.878,31.961z  M16.39,44.488v-3.669c0-0.911,0.234-1.736,0.703-2.478c0.468-0.742,1.119-1.295,1.951-1.658c1.951-0.859,3.688-1.465,5.21-1.815 c1.521-0.351,3.063-0.526,4.624-0.526s3.103,0.176,4.624,0.526c1.522,0.351,3.246,0.956,5.172,1.815 c0.832,0.39,1.488,0.949,1.971,1.678c0.48,0.729,0.721,1.547,0.721,2.458v3.669H16.39z M18.732,42.146h20.292v-1.327 c0-0.416-0.104-0.813-0.312-1.19c-0.209-0.377-0.534-0.656-0.977-0.839c-1.82-0.884-3.375-1.456-4.663-1.717 c-1.288-0.261-2.686-0.39-4.195-0.39c-1.509,0-2.907,0.136-4.195,0.409c-1.288,0.272-2.855,0.839-4.703,1.697 c-0.39,0.183-0.696,0.462-0.917,0.839s-0.332,0.774-0.332,1.19V42.146z M28.878,29.62c1.015,0,1.854-0.332,2.517-0.995 c0.664-0.664,0.995-1.502,0.995-2.517s-0.332-1.854-0.995-2.517c-0.663-0.664-1.502-0.995-2.517-0.995s-1.854,0.332-2.517,0.995 c-0.663,0.664-0.995,1.502-0.995,2.517s0.332,1.854,0.995,2.517C27.024,29.288,27.863,29.62,28.878,29.62z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelUpload);
export default __webpack_public_path__ + "static/media/cancelUpload.3c45f1088ba78846bab2b81ee781bd1f.svg";
export { ForwardRef as ReactComponent };